import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/css/nucleo-icons.css";
import "assets/scss/blk-design-system-react.scss";
import "assets/demo/demo.css";

import { UrlServicesProvider } from "components/UrlServicesContext";

import Login from "views/IndexSections/Login.js";
import SuperAdmin from "layouts/SuperAdmin.js";
import Page404 from "views/404.js";
import Payment from "views/Admin/Payment";
import PaymentApiConnection from "views/Admin/PaymentApiConnection";
import PaymentResponse from "views/Admin/PaymentResponse";
import PaymentsNotification from "views/Admin/PaymentsNotification";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <UrlServicesProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/account/*" element={<SuperAdmin />} />
        <Route path="/payment/:id" element={<Payment />} />
        <Route
          path="/payment-api-connection/:id"
          element={<PaymentApiConnection />}
        />
        <Route path="/paymentResponse" element={<PaymentResponse />} />
        <Route path="/notification" element={<PaymentsNotification />} />
        <Route path="/404" element={<Page404 />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </UrlServicesProvider>
  </BrowserRouter>
);
